import { render, staticRenderFns } from "./Brinde.vue?vue&type=template&id=3bb598b5&scoped=true"
import script from "./Brinde.vue?vue&type=script&lang=js"
export * from "./Brinde.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bb598b5",
  null
  
)

export default component.exports